import React, {useEffect, useState} from "react";
import swal from "sweetalert";
import {succesMessage} from "../../../../../../helpers/AssetsHelpers";
import {ajouterStrategiePolitiqueCom} from "../../../../../../data/stategieGlobale";
import {Button, Input, Tooltip, Typography} from "antd";
import {appTheme} from "../../../../../../config/theme";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSave} from "@fortawesome/free-solid-svg-icons";

const { Title } = Typography;

const PolitiqueCommerciale = ({ mission, strategies, isProvisoire }) => {
    const [politiqueCom, setPolitiqueCom] = useState('')
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if(strategies){
            setPolitiqueCom(strategies.politiqueCom)
        }
        else{
            setPolitiqueCom('')
        }
    }, [strategies])

    const onChange = (e) => {
        setPolitiqueCom(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)

        const data = {
            politiqueCom,
            isProvisoire: parseInt(isProvisoire) === 1,
            exercice_id: mission.id,
            client_id: mission.client_id
        }

        const {status, message} = await ajouterStrategiePolitiqueCom(data)
        if (status === 'success') {
            setLoading(false)
            await swal(succesMessage, '', 'success')
        } else {
            setLoading(false)
            await swal(message, '', 'error')
        }
    }

    return (
        <div className="d-flex flex-column fv-plugins-bootstrap5 fv-plugins-framework pb-10">
            {<div className="d-flex justify-content-end align-items-end mb-10">
                <Tooltip title="Enregistrer">
                    <Button
                        disabled={(mission.isCloture === 1 || mission.isClotureProvisoire === 1)}
                        size={"large"}
                        // loading={loading}
                        style={{
                            backgroundColor: appTheme.colors.secondary,
                            color: "white"
                        }}
                        icon={<FontAwesomeIcon style={{paddingRight: "10"}} icon={faSave}/>}
                        onClick={handleSubmit}
                    >
                        {!loading &&
                            <span className='indicator-label text-white'>Enregistrer</span>}
                        {loading && (
                            <span className='indicator-progress fs-9 text-white'
                                  style={{display: 'block'}}>
                                  Patientez svp...
                                  <span
                                      className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                        )}
                    </Button>
                </Tooltip>
            </div>}
            <div className="card-header">
                <div className="card-title">
                    <Title style={{
                        display: "block",
                        fontWeight: '600',
                        color: appTheme.colors.primary,
                        // textAlign: "center"
                    }} level={4}>{"EC4.5: POLITIQUE COMMERCIALE ET OPÉRATIONNELLE"}</Title>
                </div>
            </div>
            <div className="mt-10"></div>
            <Input.TextArea
                size="large"
                placeholder="Saissiser la politique commerciale"
                readOnly={(mission.isCloture === 1 || mission.isClotureProvisoire === 1)}
                maxLength={5000}
                showCount
                autoSize={{
                    minRows: 8,
                    maxRows: 25,
                }}
                onChange={onChange}
                value={politiqueCom}
            />
        </div>
    );
};

export default PolitiqueCommerciale;
